import React, { Component } from "react";
import withErrorHandler from "../../../hoc/withErrorHandler";
import Axios from "../../../config/axios";
import "../../../style.css";
import {
  Alert,
  PageHeader,
  Button,
  Col,
  Row,
  Skeleton,
  Divider,
  Tooltip,
  Descriptions,
  Select,
  Input,
  Tag,
  Modal,
  DatePicker,
} from "antd";
import {
  CloudDownloadOutlined,
  DownloadOutlined,
  HighlightOutlined,
  FilePdfOutlined,
  PlusOutlined,
  MinusOutlined,
  ExclamationCircleOutlined,
  EditOutlined,
  UploadOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import Loading from "../../../components/Loading";
import "./style.css";
import openNotificationWithIcon from "../../../helpers/notification";
import { baseUrl, lostLetter } from "../../../config/urls";
import { suratKehilangan } from "config/lettersId";
import { suratKeterlambatanPembayaran } from "config/lettersId";
import { suratPKL } from "config/lettersId";
import { suratMagang } from "config/lettersId";
import { displayDate } from "../../../helpers/displayDate";

const moment = require("moment");

// function officialNotFound() {
//     Modal.error({
//       title: 'Jabatan Penanda Tangan Tidak Ditemukan',
//       content: 'Jabatan penanda tangan yang ditunjuk untuk surat ini tidak ditemukan. Periksa data di simsdm dan update data jabatan.',
//     });
//   }

class DetailLetters extends Component {
  state = {
    lettercode: {},
    letter: {
      faculty_id: "",
      requester: "",
      fields: [],
      response_letter_number: "",
      fields_value: [],
      doping_doji: [],
      internship_member: [],
      letters_name: "",
      addressed: {
        identity: "",
        name: "",
        official: "",
        officer_id: "",
      },
      default_addressed: "",
      response_fields: [],
      response_fields_value: [],
      requested_file: "",
      response_file: "",
      signature: "",
      signature_date: "",
      template: "",
      response_template: "",
      thesis_detail: {
        participants: "",
        type: "",
        media: "",
        absenteeism: "",
        sign_date: "",
      },
      lost_letter_type: "",
      letterhead_type: "",
    },
    absent: "",
    responseFile: "",
    requester: {},
    loading: true,
    officials: [],
    signatureModal: false,
    editModal: false,
    checkAddressed: false,
    defaultPoints: [
      "Kemampuan Mempertahankan Hasil Penelitian",
      "Pemahaman Terhadap Wawasan Keilmuan Khususnya Ilmu Komunikasi",
      "Sikap/Penampilan",
    ],
    form: [],
    formAddressed: {
      identity: "",
      name: "",
      official: "",
      officer_id: "",
      user_id: "",
    },
    letterheadType: "fakultas",
    use_eoffice: false,
    check_code_letter: true,
    check_letter_head: true,
    isReadOnly: false,
  };

  componentDidMount() {
    this.fetchLetter();
    this.setState({ isReadOnly: this.props.user.info.type === "guest" });
  }

  fetchSettings = async () => {
    // jangan lupa diubah
    const eoffice = Axios.get(
      "/letterhead?unit_id=" +
        (this.props.user.info.type === "admin"
          ? this.state.letter.faculty_id
          : this.props.user.info.unit_id),
    );
    const checkCodeLetter = Axios.get(
      "/lettercode/check/" + this.props.match.params.id,
    );
    const checkHeadLetter = Axios.get(
      "/letterhead/check/" + this.props.match.params.id,
    );

    const settings = await Promise.all([
      checkCodeLetter,
      checkHeadLetter,
      eoffice,
    ]);

    if (settings[2].data.payload[0]) {
      this.setState({ use_eoffice: settings[2].data.payload[0].sync_eoffice });
    }
    this.setState({
      check_code_letter: settings[0].data.payload,
      check_letter_head: settings[1].data.payload,
    });
  };

  fetchLetter = () => {
    Axios.get("/requested-letters/" + this.props.match.params.id)
      .then(async (response) => {
        if (this.props.user.info.type !== "admin") {
          if (this.props.user.info.type === "operator") {
            if (this.props.user.info.unit_id !== response.data.faculty_id) {
              window.location = "/admin/surat";
            }
          } else if (this.props.user.info.type === "prodi") {
            const unit = await Axios.get(
              "/units?unit_id=" + this.props.user.info.unit_id,
            );
            if (unit.data.payload.nim_label !== response.data.major_id) {
              window.location = "/admin/surat";
            }
          }
        }
        let letter = displayDate(response.data.fields, { ...response.data });
        if ((letter.thesis || letter.thesis_defence) && !letter.rated) {
          const dopingdoji = response.data.doping_doji;
          dopingdoji.forEach((dosen, index) => {
            let temp = [];
            this.state.defaultPoints.forEach((val) => {
              temp.push({ name: val, point: "" });
            });
            letter.doping_doji[index].points = temp;
          });
        }

        this.setState(
          {
            letter,
            form: response.data.fields_value,
            formAddressed: letter.addressed,
            checkAddressed: response.data.addressed.identity ? true : false,
            letterheadType: letter.letterhead_type || "fakultas",
          },
          () => {
            this.fetchStudent();
            this.fetchOfficials();
            this.fetchSettings();
          },
        );
      })
      .catch(() => {
        window.history.go(-1);
      });
  };

  fetchStudent = () => {
    Axios.get("/users/mahasiswa/" + this.state.letter.requester).then(
      (response) => {
        this.setState({ requester: response.data, loading: false });
      },
    );
  };

  handleGoBack = () => {
    this.props.history.push({
      pathname: "/admin/surat",
      state: {
        tabKey: "2",
      },
    });
  };

  handlePrint = () => {
    this.props.history.push({
      pathname: "/surat/cetak",
      state: { letter: this.state.letter, user: this.state.requester },
    });
  };

  fetchOfficials = async () => {
    let thisUnit = [this.props.user.info.unit_id];
    const { letter } = this.state;

    //get all unit_id in faculty
    if (
      this.props.user.info.type === "operator" ||
      this.props.user.info.type === "admin"
    ) {
      const units = await Axios.get("/units");
      const seletedUnit = units.data.payload[0].children.find(
        (unit) => unit.id === this.props.user.info.unit_id,
      );

      if (seletedUnit && seletedUnit.children) {
        seletedUnit.children.forEach((unit) => {
          if (unit.nim_label === letter.major_id) {
            thisUnit.push(unit.id);
          }
        });
      }
    } else if (this.props.user.info.type === "prodi") {
      // const faculty = await Axios.get("/units?unit_id="+this.props.user.info.unit_id)
      thisUnit.push(this.state.letter.faculty_id);
    }

    // let findedOfficial = true
    // if(letter.default_addressed){
    //     findedOfficial = false
    // }
    //fetch all unit frm faculty from api
    let units = [];
    thisUnit.forEach((unit) => {
      const qs =
        (letter.letterhead_type || this.state.letterheadType) === "prodi"
          ? `/units?unit_id=${unit}&letterhead_type=prodi`
          : `/units?unit_id=${unit}`;
      units.push(Axios.get(qs));
    });
    //mapping the officials6+
    Promise.all(units).then((responses) => {
      responses.forEach((response) => {
        const position = response.data.payload.positions.find(
          (position) => letter.default_addressed === position.position_id,
        );
        const tempOfficials = response.data.payload.officials.map(
          (official) => {
            if (position && position.id === official.position_id) {
              const formAddressed = {
                identity: official.NIP,
                name: official.user,
                official: official.title,
                officer_id: official.id,
                user_id: official.user_id,
              };
              // findedOfficial = true
              this.setState({ formAddressed });
            }

            return {
              ...official,
              unit_name: official.unit_name || response.data.payload.name,
            };
          },
        );
        let { officials } = this.state;
        officials = [...officials, ...tempOfficials];

        this.setState({ officials });
      });

      // if(!findedOfficial){
      //     officialNotFound()
      // }
    });

    //    thisUnit.forEach(unit => {
    //       Axios.get("/units?unit_id="+unit).then(async(response) => {

    //         const position = response.data.data.positions.find(position => letter.default_addressed === position.position_id)
    //         const tempOfficials = await response.data.data.officials.map(official => {

    //             if(position && (position.id === official.position_id)){
    //                 letter.addressed = {
    //                     identity: official.NIP,
    //                     name: official.user,
    //                     official: official.title
    //                 }
    //                 findedOfficial = true
    //                 this.setState({ letter })
    //             }

    //             return {
    //                 ...official,
    //                 unit_name: response.data.data.name}
    //           })
    //           let { officials } = this.state
    //           officials = [...officials, ...tempOfficials]

    //           this.setState({ officials })
    //       })
    //     })
    //     console.log(findedOfficial)
    //     if(!findedOfficial){
    //         officialNotFound()
    //     }
  };

  toggleSignatureModal = () => {
    this.setState({ signatureModal: !this.state.signatureModal });
  };

  toggleEditModal = () => {
    this.setState({ editModal: !this.state.editModal });
  };

  handleOnChangeOfficial = (value) => {
    const [id, official_id] = value.split("|");
    const official = this.state.officials.find(
      (official) => official.user_id === id && official.id === official_id,
    );
    if (official) {
      this.setState({
        formAddressed: {
          name: official.user,
          identity: official.NIP,
          official: official.title,
          officer_id: official.id,
          user_id: official.user_id,
        },
      });
    }
  };

  handleOnChangeFormAddressed = (e) => {
    this.setState({
      formAdressed: {
        ...this.state.formAddressed,
        official: e.target.value,
      },
    });
  };

  handleChangeResponse = (e, fieldID) => {
    const { letter } = this.state;
    let responseValue = letter.response_fields_value;
    const finded = responseValue.find((value, index) => {
      if (value.field_id === fieldID) {
        responseValue[index] = { ...value, value: e.target.value };
        return value;
      }
      return undefined;
    });

    if (!finded) {
      responseValue.push({ field_id: fieldID, value: e.target.value });
    }

    this.setState({ letter });
  };

  sendMail = async (requester) => {
    const student = await Axios.get("/users/mahasiswa/" + requester);
    if (student.data.email) {
      Axios.post("/send-mail", {
        subject: "ASA USU - Verifikasi Ejuan Permohonan Surat",
        message:
          "Ajuan permohohonan Surat " +
          this.state.letter.letters_name +
          " Anda telah diverivikasi. Silahkan kunjungi <a href='https://asa.usu.ac.id'>asa.usu.ac.id</a> dan tanda tangani/upload permohonan surat.",
        email: student.data.email,
      }).catch((error) => console.error(error));
    }
  };

  sendMailFinished = async (record) => {
    const student = await Axios.get("/users/mahasiswa/" + record.requester);

    if (student.data.email) {
      Axios.post("/send-mail", {
        subject: "ASA USU - Surat Balasan",
        message:
          "Ajuan permohohonan Surat " +
          record.letters_name +
          " Anda telah selesai diproses. Silahkan kunjungi <a href='https://asa.usu.ac.id'>asa.usu.ac.id</a> untuk mendownload surat balasan.",
        email: student.data.email,
      }).catch((error) => console.error(error));
    }
  };

  sendMailBeritaAcara = async (record) => {
    const student = await Axios.get("/users/mahasiswa/" + record.requester);

    if (student.data.email) {
      Axios.post("/send-mail", {
        subject: "ASA USU - Berita Acara",
        message:
          "Berita acara telah untuk " +
          record.letters_name +
          " telah dikirim ke akun Anda. Silahkan kunjungi <a href='https://asa.usu.ac.id'>asa.usu.ac.id</a> untuk mendownload berita acara.",
        email: student.data.email,
      }).catch((error) => console.error(error));
    }
  };

  handleSaveAdressed = async () => {
    const { letter, formAddressed } = this.state;
    let officerData = { ...formAddressed };
    console.log(this.state.officials, officerData);
    if (!this.state.formAddressed?.user_id) {
      const temp = this.state.officials.find(
        (official) => official.id === this.state.formAddressed.officer_id,
      );

      console.log("temp", temp);
      if (temp) {
        officerData.user_id = temp.user_id;
      }
    }

    if (!officerData?.identity && officerData?.user_id) {
      try {
        const detailOfficer = await Axios.get(
          `/users/api?user_id=${officerData.user_id}`,
        );
        officerData.identity = detailOfficer.data.payload.nip;
      } catch (error) {
        console.log(error);
      }
    }

    const form = {
      ...letter,
      verified_by: this.props.user.user_id,
      addressed: officerData,
    };
    this.handleSave(form);
  };

  handleSaveResponse = () => {
    const { letter } = this.state;
    const form = { ...letter, letterhead_type: this.state.letterheadType };
    if (form.step !== "finished") {
      form.step = "finished";
      // this.sendMailFinished(form)
    }
    form.response_file = this.state.responseFile;
    const message = !form.send_response
      ? "Surat Balasan Berhasil Dikirim"
      : "Surat Balasan Telah Diubah";

    form.send_response = true;
    this.handleSave(form, message);
  };

  handleConfirmSavePoints = () => {
    Modal.confirm({
      title: "Anda Yakin Nilai Sudah Tepat?",
      content: "Setelah disimpan nilai tidak dapat diubah.",
      icon: <ExclamationCircleOutlined />,
      okText: "Ya",
      cancelText: "Tidak",
      onOk: this.handleSavePoints,
      oncancel: {},
    });
  };
  handleSavePoints = () => {
    const { letter } = this.state;
    const form = { ...letter };
    form.rated = true;
    // this.sendMailBeritaAcara(form)
    form.thesis_detail.sign_date = new Date();
    this.handleSave(form, "Nilai Berhasil Disimpan");
  };

  handleSave = (form, message = "Data Berhasil Diubah") => {
    form = { ...form, fields_value: this.state.form };
    this.setState({ loading: true });
    let formData = new FormData();
    formData.append("send_response", form.send_response);
    formData.append("step", form.step);
    formData.append("addressed", JSON.stringify(form.addressed));
    formData.append("submitted_date", form.submitted_date);
    formData.append("thesis_detail", JSON.stringify(form.thesis_detail));
    formData.append("thesis", form.thesis);
    formData.append("thesis_defence", form.thesis_defence);
    formData.append("thesis_submission", form.thesis_submission);
    formData.append("rated", form.rated);
    formData.append("requester", form.requester);
    formData.append("letters_id", form.letters_id);
    formData.append("requested_file", form.requested_file);
    formData.append("response_file", form.response_file);
    formData.append("major_id", form.major_id);
    formData.append("faculty_id", form.faculty_id);
    formData.append("processed_date", form.processed_date);
    formData.append("signature", form.signature || "");
    formData.append("signature_date", form.signature_date || "");
    formData.append("finished_date", form.finished_date || "");
    formData.append("letterhead_type", form.letterhead_type || "");
    formData.append("verified_by", form.verified_by || "");

    form.fields_value.forEach((field) => {
      formData.append("fields_value[]", JSON.stringify(field));
    });

    form.response_fields_value.forEach((field) => {
      formData.append("response_fields_value[]", JSON.stringify(field));
    });

    form.doping_doji.forEach((field) => {
      formData.append("doping_doji[]", JSON.stringify(field));
    });

    if (form.internship_member) {
      form.internship_member.forEach((field) => {
        formData.append("internship_member[]", JSON.stringify(field));
      });
    }

    if (form.rated) {
      formData.append("absent", this.state.absent);
    }

    Axios.put("/requested-letters/save/" + this.props.match.params.id, formData)
      .then(() => {
        openNotificationWithIcon("success", "Kelola Permohonan", message);
        if (this.state.letter.addressed.identity) {
          // this.sendMail(form.requester)
          this.setState({ checkAddressed: true });
        }
        this.fetchLetter();
        this.setState({ loading: false });
        this.setState({ responseFile: "" });
      })
      .catch(() => {
        this.setState({ loading: false });
      });

    // form.addressed = JSON.stringify(form.addressed)
    // form.thesis_detail = JSON.stringify(form.thesis_detail)
    // const value = form.fields_value.map(field => JSON.stringify(field))
    // const responseValue = form.response_fields_value.map(field => JSON.stringify(field))
    // const dopingDoji = form.doping_doji.map(field => JSON.stringify(field))
    // Promise.all([value, responseValue, dopingDoji]).then(result => {

    //     form.fields_value = result[0]
    //     form.response_fields_value = result[1]
    //     form.doping_doji = result[2]
    //     Axios.put("/requested-letters/save/"+this.props.match.params.id, form)
    //     .then(() => {
    //         openNotificationWithIcon('success', 'Kelola Permohonan', message)
    //         if(!this.state.checkAddressed){
    //             this.sendMail(form.requester)
    //             this.setState({ checkAddressed: true })
    //         }
    //         this.fetchLetter()
    //         this.setState({ loading: false})
    //     }).catch(() => {
    //         this.setState({ loading: false})
    //     })
    // })
  };

  handleSaveResponseLetter = () => {
    const form = {
      ...this.state.letter,
      finished_date: "1",
      letterhead_type: this.state.letterheadType,
    };
    this.handleSave(form);
  };

  handleFileClick = (file) => {
    window.open(file, "_blank");
  };

  handleChangeCategory = (e, index) => {
    let { defaultPoints } = this.state;
    defaultPoints[index] = e.target.value;
    this.setState({ defaultPoints });
  };

  addCategory = () => {
    let { defaultPoints } = this.state;
    defaultPoints.push("");
    this.setState({ defaultPoints });
  };

  removeCategory = (index) => {
    let { defaultPoints } = this.state;
    defaultPoints.splice(index, 1);
    this.setState({ defaultPoints });
  };

  handleSaveCategory = () => {
    let { letter } = this.state;
    letter.doping_doji.forEach((dosen, index) => {
      let temp = [];
      this.state.defaultPoints.forEach((val) => {
        temp.push({ name: val, point: "" });
      });
      letter.doping_doji[index].points = temp;
    });
    this.setState({ letter });
  };

  handleChangePoints = (e, lecturerID, indexPoint) => {
    const { letter } = this.state;
    let dopingDoji = letter.doping_doji;
    dopingDoji.forEach((value, index) => {
      if (value._id === lecturerID) {
        dopingDoji[index].points[indexPoint].point = e.target.value;
        this.setState({ letter });
        return;
      }
    });
  };

  handleChangeThesisDetail = (e) => {
    let { letter } = this.state;
    letter.thesis_detail[e.target.name] = e.target.value;
    this.setState({ letter });
  };

  handleChangeFile = (e) => {
    let { absent } = this.state;
    absent = e.target.files[0];
    this.setState({ absent });
  };

  handleChangeResponseFile = (e) => {
    let { responseFile } = this.state;
    responseFile = e.target.files[0];
    this.setState({ responseFile });
  };

  handleChangeLetterheadType = (e) => {
    this.setState({
      letterheadType: e.target.value,
    });
  };

  handleChangeForm = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    const fieldsValue = this.state.form.map((field) => {
      if (name === field.field_id) {
        return {
          ...field,
          value,
        };
      }
      return field;
    });
    this.setState({ form: fieldsValue });
  };

  handleSaveForm = () => {
    this.setState(
      { letter: { ...this.state.letter, fields_value: this.state.form } },
      () => {
        const { letter } = this.state;
        this.handleSave(letter);
        this.toggleEditModal();
      },
    );
  };

  handleGetNoLetter = async () => {
    try {
      const response = await Axios.post(
        "/requested-letters/" + this.props.match.params.id + "/save-no-letter",
        {
          user_id: this.props.user.user_id,
          requester_name: this.state.requester["nama"],
        },
      );

      this.setState({
        letter: response.data,
      });
    } catch (error) {
      console.error(error);
    }
  };

  render() {
    const {
      fields,
      fields_value: fieldsValue,
      response_fields: responseFields,
      response_fields_value: responseValue,
      doping_doji: dopingDoji,
      lost_letter_type: lostLetterType,
    } = this.state.letter;
    return (
      <>
        <div className="site-layout-background" style={{ padding: 10 }}>
          <PageHeader
            className="site-page-header"
            onBack={this.handleGoBack}
            title="Permohonan Surat"
            subTitle={<Tag color="green">{this.state.letter.letters_name}</Tag>}
          >
            <Skeleton active={true} loading={this.state.loading}>
              <Descriptions size="small" column={3}>
                <Descriptions.Item label="Nama">
                  {this.state.requester["nama"]}
                </Descriptions.Item>
                <Descriptions.Item label="Program Studi">
                  {this.state.requester["program_studi"]}
                </Descriptions.Item>
                <Descriptions.Item
                  label={
                    this.state.letter.send_response
                      ? "Tanggal Selesai"
                      : "Tanggal Diproses"
                  }
                >
                  {moment(
                    this.state.letter.send_response
                      ? this.state.letter.finished_date
                      : this.state.letter.processed_date,
                  ).format("lll")}
                </Descriptions.Item>
                <Descriptions.Item label="NIM">
                  {this.state.requester["nim"]}
                </Descriptions.Item>
                <Descriptions.Item label="Email">
                  {this.state.requester["email"]}
                </Descriptions.Item>
              </Descriptions>
            </Skeleton>
          </PageHeader>
        </div>
        <Row style={{ marginTop: 24 }}>
          <Col span={24}>
            <Alert
              message="Status Surat Mahasiswa"
              showIcon
              type={
                this.state.letter.step === "finished"
                  ? "success"
                  : this.state.letter.step === "rejected"
                    ? "error"
                    : "info"
              }
              description={
                !this.state.checkAddressed
                  ? "Silahkan pilih penanda tangan dan verifikasi surat"
                  : !this.state.letter.requested_file &&
                      !this.state.letter.signature
                    ? "Tunggu mahasiswa menggunggah/menanda tangani surat"
                    : this.state.letter.step === "finished"
                      ? "Surat telah selesai diproses"
                      : this.state.letter.requested_file ||
                          this.state.letter.signature
                        ? "Silahkan unduh surat balasan"
                        : this.state.letter.step === "rejected"
                          ? "Surat permohonan ditolak"
                          : ""
              }
            />
          </Col>
        </Row>
        <Row>
          <Col
            className="site-layout-background card mt-2 p-1"
            xxl={6}
            xl={10}
            lg={10}
            md={16}
            sm={24}
            xs={24}
          >
            <h3>
              <strong>Penanda Tangan</strong>
            </h3>
            <div>
              <Select
                showSearch
                style={{ width: "100%" }}
                placeholder="Pilih User"
                disabled={
                  this.state.letter.step === "finished" || this.state.isReadOnly
                }
                optionFilterProp="children"
                onChange={this.handleOnChangeOfficial}
                value={
                  this.state.formAddressed.officer_id
                    ? (this.state.formAddressed.name || "") +
                      " - " +
                      (this.state.formAddressed.official +
                        " - " +
                        this.state.formAddressed.officer_id || "")
                    : null
                }
              >
                {this.state.officials.map((official, index) => (
                  <Select.Option
                    key={index}
                    value={`${official.user_id}|${official.id}`}
                  >
                    {official.user}
                    <br />
                    {official.title}
                    <br />
                    {official.unit_name}
                  </Select.Option>
                ))}
              </Select>
              <Input
                className="mt-5"
                placeholder="Jabatan"
                disabled={
                  this.state.letter.step === "finished" || this.state.isReadOnly
                }
                value={this.state.formAddressed.official}
                onChange={this.handleOnChangeFormAddressed}
              />
              <div
                style={{ position: "relative", float: "right", marginTop: 10 }}
              >
                <Button
                  disabled={
                    this.state.letter.step === "finished" ||
                    this.state.isReadOnly
                  }
                  onClick={this.handleSaveAdressed}
                  type="primary"
                  shape="round"
                >
                  {!this.state.checkAddressed ? "Verifikasi" : "Simpan"}
                </Button>
              </div>
            </div>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col className="mt-2" xxl={6} xl={10} lg={10} md={16} sm={24} xs={24}>
            <div className="site-layout-background card ">
              <Row justify="space-between" style={{ marginBottom: 10 }}>
                <Col>
                  <h3>
                    <strong>Permohonan Surat</strong>
                  </h3>
                </Col>
                <Col>
                  <Row gutter={8}>
                    {!this.state.loading && !this.state.isReadOnly ? (
                      <Col>
                        <a
                          key="1"
                          href={
                            baseUrl +
                            "/requested-letters/export-to-pdf/request/" +
                            this.props.match.params.id +
                            (this.props.user.info.type === "prodi"
                              ? "/" + this.props.user.info.unit_id
                              : "")
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <Tooltip title="Download PDF">
                            <Button
                              size="large"
                              type="primary"
                              shape="circle"
                              icon={<FilePdfOutlined />}
                            />
                          </Tooltip>
                        </a>
                      </Col>
                    ) : null}
                    {!this.state.loading &&
                    this.state.letter.requested_file &&
                    !this.state.isReadOnly ? (
                      <Col>
                        <a
                          key="2"
                          href={this.state.letter.requested_file}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <Tooltip title="Download Surat Permohonan">
                            <Button
                              size="large"
                              type="primary"
                              shape="circle"
                              icon={<DownloadOutlined />}
                            />
                          </Tooltip>
                        </a>
                      </Col>
                    ) : null}
                    {!this.state.loading &&
                    this.state.letter.signature &&
                    !this.state.isReadOnly ? (
                      <Col>
                        <Tooltip key="3" title="Lihat Tanda Tangan">
                          <Button
                            onClick={this.toggleSignatureModal}
                            size="large"
                            type="primary"
                            shape="circle"
                            icon={<HighlightOutlined />}
                          />
                        </Tooltip>
                      </Col>
                    ) : null}
                    <Col>
                      <Tooltip key="4" title="Edit Surat">
                        <Button
                          disabled={
                            this.state.letter.step === "finished" ||
                            this.state.isReadOnly
                          }
                          onClick={this.toggleEditModal}
                          size="large"
                          type="primary"
                          shape="circle"
                          icon={<EditOutlined />}
                        />
                      </Tooltip>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <div className="mt-5">
                {fields.map((field) => {
                  const value = fieldsValue.find(
                    (detail) => detail.field_id === field._id,
                  );
                  return (
                    <div key={field._id}>
                      <div>
                        <strong>{field.label}</strong>
                      </div>
                      <Skeleton
                        active={true}
                        paragraph={0}
                        loading={value ? false : true}
                      >
                        {value ? (
                          ["text", "textarea"].includes(field.field_type) ? (
                            value.value
                          ) : (
                            <Button
                              onClick={() => this.handleFileClick(value.value)}
                            >
                              <DownloadOutlined /> Unduh
                            </Button>
                          )
                        ) : (
                          ""
                        )}
                        <div></div>
                      </Skeleton>
                      <Divider type="horizontal" style={{ marginTop: 10 }} />
                    </div>
                  );
                })}
                {this.state.letter.letters_id === suratKehilangan ? (
                  <div>
                    <div>
                      <strong>Kehilangan</strong>
                    </div>
                    <Skeleton
                      active={true}
                      paragraph={0}
                      loading={
                        this.state.letter.lost_letter_type ? false : true
                      }
                    >
                      {this.state.letter.lost_letter_type}
                    </Skeleton>
                    <Divider type="horizontal" style={{ marginTop: 10 }} />
                  </div>
                ) : null}
                {this.state.letter.letters_id ===
                suratKeterlambatanPembayaran ? (
                  <>
                    <div>
                      <div>
                        <strong>Jenis Keterlambatan</strong>
                      </div>
                      <Skeleton
                        active={true}
                        paragraph={0}
                        loading={this.state.letter ? false : true}
                      >
                        {this.state.letter.additional_late_payment_value2}
                      </Skeleton>
                      <Divider type="horizontal" style={{ marginTop: 10 }} />
                    </div>
                    <div>
                      <div>
                        <strong>Cover ACC Sidang Meja Hijau</strong>
                      </div>
                      <Skeleton
                        active={true}
                        paragraph={0}
                        loading={this.state.letter ? false : true}
                      >
                        <Button
                          onClick={() =>
                            this.handleFileClick(
                              this.state.letter.additional_late_payment_value,
                            )
                          }
                        >
                          <DownloadOutlined /> Unduh
                        </Button>
                      </Skeleton>
                      <Divider type="horizontal" style={{ marginTop: 10 }} />
                    </div>
                  </>
                ) : null}
                {dopingDoji
                  ? dopingDoji.map((dosen, index) => (
                      <div key={index}>
                        <div>
                          <strong>{dosen.type}</strong>
                        </div>
                        <Skeleton
                          active={true}
                          paragraph={0}
                          loading={this.state.loading}
                        >
                          {dosen.name}
                          <div></div>
                        </Skeleton>
                        <Divider type="horizontal" style={{ marginTop: 10 }} />
                      </div>
                    ))
                  : null}
                {lostLetter === this.props.match.params.id ? (
                  <div>
                    <div>
                      <strong>Kehilangan</strong>
                    </div>
                    <Skeleton
                      active={true}
                      paragraph={0}
                      loading={this.state.loading}
                    >
                      {lostLetterType}
                      <div></div>
                    </Skeleton>
                    <Divider type="horizontal" style={{ marginTop: 10 }} />
                  </div>
                ) : null}
                {[suratPKL, suratMagang].includes(
                  this.state.letter.letters_id,
                ) ? (
                  <>
                    <div>
                      <div>
                        <strong>Tipe</strong>
                      </div>
                      <Skeleton
                        active={true}
                        paragraph={0}
                        loading={this.state.loading}
                      >
                        {this.state.letter.internship_type}
                        <div></div>
                      </Skeleton>
                      <Divider type="horizontal" style={{ marginTop: 10 }} />
                    </div>
                    {this.state.letter.internship_type === "kelompok" ? (
                      <div>
                        <div>
                          <strong>Anggota Kelompok</strong>
                        </div>
                        <Skeleton
                          active={true}
                          paragraph={0}
                          loading={this.state.loading}
                        >
                          <table>
                            <tr>
                              <th>NIM</th>
                              <th>Nama</th>
                            </tr>
                            {this.state.letter.internship_member.map(
                              (member, index) => (
                                <tr key={index}>
                                  <td style={{ padding: 5 }}>{member.name}</td>
                                  <td>{member.nim}</td>
                                </tr>
                              ),
                            )}
                          </table>
                          <div></div>
                        </Skeleton>
                        <Divider type="horizontal" style={{ marginTop: 10 }} />
                      </div>
                    ) : null}
                  </>
                ) : null}
              </div>
            </div>
          </Col>

          <Col className="mt-2" xxl={8} xl={10} lg={14} md={16} sm={24} xs={24}>
            <div className="site-layout-background card ">
              <Row>
                <Col>
                  <h3>
                    <strong>Surat Balasan</strong>
                  </h3>
                </Col>
                {/* <Col style={{position:'absolute', right:30}}>
                                    {
                                        !this.state.loading ?
                                        <a href={baseUrl+"/requested-letters/export-to-pdf/response/"+this.props.match.params.id+(this.state.letterheadType === 'prodi' ? '/'+this.state.letter.major_id : '')} target="_blank" rel="noopener noreferrer">                                   
                                        <Tooltip title="Download PDF">
                                            <Button size="large" type="primary" style={{position:'absolute', right:20}} shape="circle" icon={<FilePdfOutlined />} />
                                        </Tooltip>  
                                        </a>  :null
                                    }
                                </Col>                           */}
              </Row>
              <Row>
                {!this.state.check_code_letter ? (
                  <Col span={24}>
                    <Alert
                      type="error"
                      message="Kode Surat Belum Diatur"
                      description="Buka menu Nomor Surat, lalu masukkan kode surat pada surat yang diinginkan. Jika menggunakan kode surat prodi, hubungi admin prodi"
                    />
                  </Col>
                ) : null}
                {!this.state.check_letter_head ? (
                  <Col span={24}>
                    <Alert
                      type="error"
                      message="Kop Surat Belum Diatur"
                      description="Upload kop surat di menu pengaturan. Jika menggunakan kop surat prodi, hubungi admin prodi"
                    />
                  </Col>
                ) : null}
                {this.state.letter.step === "finished" ? (
                  <Col span={24}>
                    <Alert
                      type="success"
                      message="Surat Balasan sudah dikirim"
                    />
                  </Col>
                ) : null}
              </Row>
              <div className="mt-5">
                {/* <Row>
                                <Col span={24}>
                                    <label>Kop Surat</label>
                                </Col>
                                <Col>
                                <Radio.Group
                                    disabled={ !this.state.lettercode || this.state.letter.step === 'finished' || (!this.state.letter.requested_file && !this.state.letter.signature)}
                                    onChange={this.handleChangeLetterheadType} 
                                    name="letterhead_type" 
                                    value={this.state.letterheadType}
                                >
                                    <Radio value="fakultas">Fakultas</Radio>
                                    <Radio value="prodi">Prodi</Radio>                                  
                                </Radio.Group>
                                </Col>
                            </Row> */}

                {/* TODO: disable eoffice   */}
                {/* {this.state.letter.use_letter_number &&
                this.state.use_eoffice ? (
                  <div>
                    <label>Nomor Surat</label>
                    <div>
                      {this.state.letter.response_letter_number ||
                        "Belum Ada No. Surat"}
                    </div>
                  </div>
                ) : null} */}
                <div>
                  <label>Kop Surat</label>
                  <div>{`Menggunakan kop surat ${this.state.letter.letterhead_type}`}</div>
                  <div style={{ fontSize: 12 }}>
                    NB: Jika surat menggunakan kop surat prodi dan kop surat
                    prodi yang bersangkutan belum tersedia maka akan digunakan
                    kop surat fakultas
                  </div>
                </div>
                {responseFields.length > 0
                  ? responseFields.map((field) => {
                      const value = responseValue.find(
                        (detail) => detail.field_id === field._id,
                      );
                      // TODO: Disable Eoffice
                      //   if (field.name === "no_surat" && this.state.use_eoffice)
                      //     return null;
                      return (
                        <div key={field._id} style={{ marginBottom: 10 }}>
                          <label>{field.label}</label>
                          <Input
                            name={field.name}
                            placeholder={field.placeholder}
                            value={value ? value.value : ""}
                            disabled={
                              !this.state.check_code_letter ||
                              this.state.letter.step === "finished" ||
                              (!this.state.letter.requested_file &&
                                !this.state.letter.signature)
                            }
                            onChange={(e) =>
                              this.handleChangeResponse(e, field._id)
                            }
                          />
                        </div>
                      );
                    })
                  : "Tidak ada field yang harus diisi"}

                {this.state.letter.requested_file ||
                this.state.letter.signature ? (
                  <Row gutter={[16, 8]} style={{ marginTop: 12 }}>
                    {this.state.use_eoffice ? (
                      <Col span={24}>
                        <Alert
                          type="warning"
                          message="Sinkornisasi No. surat dengan E-Office sedang dalam penyesuaian diakrenakan telah rilis SEPTIA. Masukkan No. surat secara manual untuk sementara waktu."
                        />
                        <Button
                          style={{ width: "100%" }}
                          shape="round"
                          //   disabled={
                          //     ((!this.state.check_code_letter ||
                          //       this.state.letter.step === "finished") &&
                          //       this.state.letter.use_letter_number) ||
                          //     this.state.loading
                          //   }
                          disabled
                          type="primary"
                          icon={<CloudDownloadOutlined />}
                          onClick={this.handleGetNoLetter}
                        >
                          Dapatkan Nomor Surat
                        </Button>
                      </Col>
                    ) : null}
                    <Col span={24}>
                      <Button
                        style={{ width: "100%" }}
                        shape="round"
                        disabled={
                          !this.state.check_code_letter ||
                          this.state.letter.step === "finished" ||
                          this.state.isReadOnly
                        }
                        type="primary"
                        icon={<SaveOutlined />}
                        onClick={this.handleSaveResponseLetter}
                      >
                        Simpan & Dapatkan Tahun Surat
                      </Button>
                    </Col>
                  </Row>
                ) : null}

                <div style={{ marginTop: 26 }}>
                  <p style={{ lineHeight: "6px" }}>
                    Download surat balasan dan tanda tangani.
                  </p>
                  <Button
                    type="link"
                    href={
                      baseUrl +
                      "/requested-letters/export-to-pdf/response/" +
                      this.props.match.params.id
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                    disabled={this.state.isReadOnly}
                  >
                    Download Surat Balasan
                  </Button>
                  <p style={{ marginTop: 16 }}>
                    Kemudian upload kembali surat balasan disini:{" "}
                  </p>
                  <input
                    style={{ marginTop: 10 }}
                    type="file"
                    name="response_file"
                    onChange={this.handleChangeResponseFile}
                    disabled={this.state.isReadOnly}
                  />
                </div>
              </div>

              <Row style={{ marginTop: 26 }} justify="center" gutter={[16, 16]}>
                {(this.state.letter.requested_file ||
                  this.state.letter.signature) &&
                this.state.check_code_letter ? (
                  <Col>
                    <Button
                      icon={<UploadOutlined />}
                      disabled={
                        this.state.loading ||
                        this.state.letter.rated ||
                        !this.state.responseFile ||
                        this.state.isReadOnly
                      }
                      style={{ float: "right" }}
                      onClick={this.handleSaveResponse}
                      type="primary"
                      shape="round"
                    >
                      Kirim Surat Balasan
                    </Button>
                  </Col>
                ) : null}
                {this.state.letter.response_file &&
                this.state.check_code_letter &&
                !this.state.isReadOnly ? (
                  <Col>
                    <a
                      href={this.state.letter.response_file}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Button shape="round" icon={<DownloadOutlined />}>
                        Download Surat Balasan
                      </Button>
                    </a>
                  </Col>
                ) : null}
              </Row>
            </div>
            {this.state.letter.thesis || this.state.letter.thesis_defence ? (
              <>
                <div
                  className="site-layout-background card "
                  style={{ marginTop: 20 }}
                >
                  <Row>
                    <Col>
                      <h3>
                        <strong>Kategori Penilaian</strong>
                      </h3>
                    </Col>
                    <Col style={{ position: "absolute", right: 30 }}>
                      {!this.state.loading && !this.state.letter.rated ? (
                        <Tooltip title="Tambah Kategori Penilaian">
                          <Button
                            size="large"
                            type="primary"
                            onClick={this.addCategory}
                            style={{ position: "absolute", right: 20 }}
                            shape="circle"
                            icon={<PlusOutlined />}
                          />
                        </Tooltip>
                      ) : null}
                    </Col>
                  </Row>
                  <div className="mt-5">
                    {this.state.defaultPoints.map((field, index) => {
                      return (
                        <div
                          key={index}
                          style={{ marginBottom: 10 }}
                          className="mt-5"
                        >
                          <Row>
                            <Input
                              name="kategori_penilaian"
                              placeholder={"Masukkan Kategori"}
                              value={field}
                              onChange={(e) =>
                                this.handleChangeCategory(e, index)
                              }
                              style={{ width: "90%" }}
                              disabled={this.state.letter.rated}
                            />
                            <Button
                              disabled={this.state.letter.rated}
                              type="danger"
                              icon={<MinusOutlined />}
                              onClick={() => this.removeCategory(index)}
                            />
                          </Row>
                        </div>
                      );
                    })}
                  </div>

                  <div
                    style={{
                      position: "relative",
                      float: "none",
                      marginTop: 10,
                      minHeight: 30,
                    }}
                  >
                    {this.state.letter.requested_file ||
                    this.state.letter.signature ? (
                      <Button
                        disabled={this.state.loading || this.state.letter.rated}
                        style={{ float: "right" }}
                        onClick={this.handleSaveCategory}
                        type="primary"
                        shape="round"
                      >
                        Simpan
                      </Button>
                    ) : null}
                  </div>
                </div>

                <div
                  className="site-layout-background card "
                  style={{ marginTop: 20 }}
                >
                  <Row>
                    <Col>
                      <h3>
                        <strong>Berita Acara</strong>
                      </h3>
                    </Col>

                    <Col style={{ position: "absolute", right: 50 }}>
                      {!this.state.loading &&
                      this.state.letter.thesis_detail.absenteeism ? (
                        <a
                          href={this.state.letter.thesis_detail.absenteeism}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ marginRight: 10 }}
                        >
                          <Tooltip title="Download Absensi">
                            <Button
                              size="large"
                              type="primary"
                              shape="circle"
                              icon={<DownloadOutlined />}
                            />
                          </Tooltip>
                        </a>
                      ) : null}
                      {!this.state.loading ? (
                        <a
                          href={
                            baseUrl +
                            "/requested-letters/export-berita-acara/" +
                            this.props.match.params.id
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <Tooltip title="Download PDF">
                            <Button
                              size="large"
                              type="primary"
                              shape="circle"
                              icon={<FilePdfOutlined />}
                            />
                          </Tooltip>
                        </a>
                      ) : null}
                    </Col>
                  </Row>
                  <div style={{ marginBottom: 10 }}>
                    <label>
                      Jumlah Peserta{" "}
                      {this.state.letter.thesis
                        ? this.state.letter.thesis_detail.type
                        : this.state.letter.thesis_defence
                          ? "Ujian Skripsi"
                          : ""}
                    </label>
                    <Input
                      name="participants"
                      value={
                        this.state.letter.thesis_detail
                          ? this.state.letter.thesis_detail.participants
                          : null
                      }
                      onChange={this.handleChangeThesisDetail}
                      placeholder="Masukkan jumlah Peserta"
                    />
                  </div>

                  <div style={{ marginBottom: 10 }}>
                    <label>Media/Aplikasi yang Digunakan</label>
                    <Input
                      name="media"
                      value={
                        this.state.letter.thesis_detail
                          ? this.state.letter.thesis_detail.media
                          : null
                      }
                      onChange={this.handleChangeThesisDetail}
                      placeholder="Kosongkan jika dilakukan secara offline"
                    />
                  </div>

                  <div style={{ marginBottom: 20 }}>
                    <label>Absensi</label>
                    <br />
                    <input type="file" onChange={this.handleChangeFile} />
                  </div>

                  <h4>Penilaian</h4>
                  <div className="mt-5">
                    {dopingDoji
                      ? dopingDoji.map((field) => {
                          return (
                            <div key={field._id} style={{ marginBottom: 10 }}>
                              <label>{field.name}</label>
                              {field.points.map((point, index) => (
                                <Input
                                  className="mt-5"
                                  key={index + field._id}
                                  name="point"
                                  type="number"
                                  disabled={this.state.letter.rated}
                                  placeholder={point.name}
                                  value={point.point}
                                  onChange={(e) =>
                                    this.handleChangePoints(e, field._id, index)
                                  }
                                />
                              ))}
                            </div>
                          );
                        })
                      : null}
                  </div>

                  <div
                    style={{
                      position: "relative",
                      float: "none",
                      marginTop: 10,
                      minHeight: 30,
                    }}
                  >
                    {this.state.letter.requested_file ||
                    this.state.letter.signature ? (
                      <Button
                        disabled={this.state.loading || this.state.letter.rated}
                        style={{ float: "right" }}
                        onClick={this.handleConfirmSavePoints}
                        type="primary"
                        shape="round"
                      >
                        {this.state.letter.send_response
                          ? "Simpan"
                          : "Kirim"}{" "}
                      </Button>
                    ) : null}
                  </div>
                </div>
              </>
            ) : null}
          </Col>
        </Row>

        <Modal
          footer={null}
          visible={this.state.signatureModal}
          onCancel={this.toggleSignatureModal}
        >
          <img src={this.state.letter.signature} alt="signature" />
        </Modal>

        <Modal
          visible={this.state.editModal}
          onCancel={this.toggleEditModal}
          onOk={this.handleSaveForm}
          title="Edit Surat Permohonan"
          okText="Simpan"
          cancelText="Batal"
        >
          {fields.map((field) => {
            const value = this.state.form.find(
              (detail) => detail.field_id === field._id,
            );
            if (!value || field.field_type !== "text") return null;

            if (field.name.includes("tanggal") || field.name.includes("tgl")) {
              return (
                <div key={field._id}>
                  <div>
                    <strong>{field.label}</strong>
                  </div>
                  <DatePicker
                    value={
                      typeof value.value === "string"
                        ? moment(value.value)
                        : value.value
                    }
                    onChange={(_date, dateString) =>
                      this.handleChangeForm({
                        target: { name: field._id, value: dateString },
                      })
                    }
                  />
                </div>
              );
            }
            return (
              <div key={field._id}>
                <div>
                  <strong>{field.label}</strong>
                </div>
                <Input
                  value={value.value}
                  name={field._id}
                  required
                  onChange={this.handleChangeForm}
                />
              </div>
            );
          })}
        </Modal>
        <Loading loading={this.state.loading || this.props.loading} />
      </>
    );
  }
}

export default withErrorHandler(DetailLetters, Axios);
